var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"loadingTxt"},[_c('i',{staticClass:"el-icon-loading"}),_c('div',{staticClass:"text"},[_vm._v("\n      解析中\n    ")]),_c('span',[_vm._v(_vm._s(_vm.dot==0?'':_vm.dot==1?'.':_vm.dot==2?'..':_vm.dot==3?'...':''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }